// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_CarregaScheduledMessagesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /mensagens_programadas/carrega_scheduled_messages
 *
 * No body required — date range and franchise IDs are derived from
 * filtro_model (session-scoped global filter).
 */
import { registerContract } from './validate'

export interface MensagensProgramadas_CarregaScheduledMessagesInput {}

registerContract('MensagensProgramadas_CarregaScheduledMessagesInput', {})
